import React, { useContext, useState, useEffect } from "react";
import "./Events.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarDays,
  faEllipsis,
  faSterlingSign,
  faTicket,
  faCoins,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import eventPic from "../../../../assets/concert.png";
import jobPic from "../../../../assets/job.png";
import religiousPic from '../../../../assets/religious.png'
import charityPic from '../../../../assets/charity.png'
import sportsPic from '../../../../assets/sports.png'
import CreateEvent from "./CreateEvent";
import EventContext from "./EventContext";
import axios from "axios";
import UserContext from "../../../../UserContext";
import EditEvent from "./EditEvent";
import { toast, ToastContainer } from "react-toastify";
import LoadingScreen from "../../../../LoadingScreen";

const Events = () => {
  const [activeOption, setActiveOption] = useState("active");
  const { createEvent, handleCreateEvent, editEvent, handleEditEvent,getEventDetails,events,setEvents,expiredEvents,getExpiredEvents,activeEvents,setActiveEvents } = useContext(EventContext);
  const { userInfo } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(true);
  const [expiredLoading, setExpiredLoading] = useState(true)
  const [setting, setSetting] = useState({ flag: false, id: null });


  const handleDeleteProcess = async () => {
    const confirmation = window.confirm("Are you sure you want to delete this event?");
  
    if (confirmation) {
      try {
        const resp = await axios.delete(
          `https://event-finder12.onrender.com/events/deleteevent/${setting.id}`
        );
        console.log(resp);
        toast.success('Successfully Deleted the event')
        const filteredEvents = events.filter((event) => event._id !== setting.id);
        setEvents(filteredEvents);
        setSetting({ flag: false, id: null });
        getExpiredEvents(userInfo.email);
      } catch (err) {
        console.log(err);
      }
    }
  }

  const handleSettingSelected = async (option) => {
    if (option === "delete") {
      handleDeleteProcess();
    }

    if (option === "edit") {
      handleEditEvent();
      setSetting({ flag: false, id: null });
    }
  };


  const handleOptions = (e) => {
    setActiveOption(e.target.id);
    console.log(e.target.id);
  };

  const handleCreate = () => {
    handleCreateEvent();
  };

  const getAllEvents = async () => {
    try {
      const resp = await axios.get(
        `https://event-finder12.onrender.com/events/getAllEvents/${userInfo.email}`
      );
      setEvents(resp.data);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleSettingOptions = (eventId) => {
    if (setting.flag && setting.id === eventId) {
      setSetting({ flag: false, id: null });
    } else {
      setSetting({ flag: true, id: eventId });
      getEventDetails(eventId)
    }
    console.log("Setting -", eventId);
  };

  useEffect(() => {
    getAllEvents();
    getExpiredEvents(userInfo.email).then(()=> {
      setExpiredLoading(false);
    })

  }, [events]); 


  return (
    <>
    <ToastContainer/>
      {!createEvent && !editEvent && (
        <>
          {isLoading || expiredLoading ? (
           <LoadingScreen/>
          ) : (
            <>
              <div className="event-outer-container">
                <div className="event-settings-container">
                  <div className="event-header">
                    <div className="event-header-title">
                      <h3>Your Events</h3>
                    </div>
                    <div onClick={handleCreate} className="event-create-container">
                      + Create
                    </div>
                  </div>
                  <div className="event-options">
                    <div
                      onClick={handleOptions}
                      id="active"
                      className={`event-option ${activeOption === "active" ? "active-option" : ""}`}
                    >
                      <h4 id="active" className="event-option-title">
                        Active
                      </h4>
                      <h5 id="active" className="event-option-length">
                        {events.length - expiredEvents.length}
                      </h5>
                    </div>
                    <div
                      onClick={handleOptions}
                      id="expired"
                      className={`event-option ${activeOption === "expired" ? "active-option" : ""}`}
                    >
                      <h4 id="expired" className="event-option-title">
                        Expired
                      </h4>
                      <h5 id="expired" className="event-option-length">
                        {!expiredEvents.length ? 0 : expiredEvents.length}
                      </h5>
                    </div>
                  </div>
                  <div className="event-list-container">
                    {activeOption==='active' && events.length > 0 ? (
                      events.map((event) => !event.expired ? (
                        <div className="event-info-container" key={event._id}>
                          <div className="event-info-first">
                            <div className="event-info-left">
                              <img
                                className="event-info-icon"
                                src={event.tag==='Music'? eventPic : event.tag==='Charity Event' ? charityPic : event.tag==='Job Event' ? jobPic : event.tag==='Sports' ? sportsPic : event.tag==='Religious Event' ? religiousPic : null}
                                alt="Event Icon"
                              />
                              <div className="event-info-heading">
                                <h3 className="event-info-title">
                                  {event.title}
                                </h3>
                                <h4 className="event-info-subtitle">
                                {event.description.length > 83 ?  event.description.slice(0,83)+"..." : event.description}
                                </h4>
                              </div>
                            </div>
                            <div className="event-info-right">
                              <div className="event-info-date">
                                <FontAwesomeIcon icon={faCalendarDays} />
                                <h4>{event.date.split("T")[0]}</h4>
                              </div>
                              <div
                                onClick={() => handleSettingOptions(event._id)}
                                className="event-info-settings"
                              >
                                <FontAwesomeIcon icon={faEllipsis} />
                              </div>
                              {setting.flag && setting.id === event._id && (
                                <ul className="setting-selected-options">
                                  <li id="delete" onClick={() => handleSettingSelected("delete")}>
                                    Delete
                                  </li>
                                  <li id="edit" onClick={() => handleSettingSelected("edit")}>
                                    Edit
                                  </li>
                                </ul>
                              )}
                            </div>
                          </div>
                          <div className="event-info-second">
                            <div className="event-info-left">
                              <div className="event-info-tag">
                                <h3>{event.tag}</h3>
                              </div>
                              <div className="event-info-location">
                                <FontAwesomeIcon icon={faLocationDot} />
                                <h3>{event.location.city}</h3>
                              </div>
                            </div>

                            <div className="event-info-right">
                              <div className="event-info-details">
                                <div className="event-info-details-title">
                                  <FontAwesomeIcon icon={faSterlingSign} />
                                  <h3>Price</h3>
                                </div>
                                <h3>
                                  {event.ticketPrice === 0
                                    ? "Free"
                                    : event.ticketPrice}
                                </h3>
                              </div>
                              <div className="event-info-details">
                                <div className="event-info-details-title">
                                  <FontAwesomeIcon icon={faTicket} />
                                  <h3>Sold</h3>
                                </div>
                                <h3>{event.ticketSold}</h3>
                              </div>

                              <div className="event-info-details">
                                <div className="event-info-details-title">
                                  <FontAwesomeIcon icon={faCoins} />
                                  <h3>Income</h3>
                                </div>
                                <h3>£ {event.income}</h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : "")
                    ) : activeOption === 'expired' && expiredEvents.length > 0 ? (
                      expiredEvents.map((event) => (
                        <div className="event-info-container" key={event._id}>
                          <div className="event-info-first">
                            <div className="event-info-left">
                              <img
                                className="event-info-icon"
                                src={eventPic}
                                alt="Event Icon"
                              />
                              <div className="event-info-heading">
                                <h3 className="event-info-title">
                                  {event.title}
                                </h3>
                                <h4 className="event-info-subtitle">
                                {event.description.length > 83 ?  event.description.slice(0,83)+"..." : event.description}
                                </h4>
                              </div>
                            </div>
                            <div className="event-info-right">
                              <div className="event-info-date">
                                <FontAwesomeIcon icon={faCalendarDays} />
                                <h4 style={{color:"red"}}>{event.date.split("T")[0]}</h4>
                              </div>
                              <div
                                onClick={() => handleSettingOptions(event._id)}
                                className="event-info-settings"
                              >
                                <FontAwesomeIcon icon={faEllipsis} />
                              </div>
                              {setting.flag && setting.id === event._id && (
                                <ul className="setting-selected-options">
                                  <li id="delete" onClick={() => handleSettingSelected("delete")}>
                                    Delete
                                  </li>
              
                                </ul>
                              )}
                            </div>
                          </div>
                          <div className="event-info-second">
                            <div className="event-info-left">
                              <div className="event-info-tag">
                                <h3>{event.tag}</h3>
                              </div>
                              <div className="event-info-location">
                                <FontAwesomeIcon icon={faLocationDot} />
                                <h3>{event.location.city}</h3>
                              </div>
                            </div>

                            <div className="event-info-right">
                              <div className="event-info-details">
                                <div className="event-info-details-title">
                                  <FontAwesomeIcon icon={faSterlingSign} />
                                  <h3>Price</h3>
                                </div>
                                <h3>
                                  {event.ticketPrice === 0
                                    ? "Free"
                                    : event.ticketPrice}
                                </h3>
                              </div>
                              <div className="event-info-details">
                                <div className="event-info-details-title">
                                  <FontAwesomeIcon icon={faTicket} />
                                  <h3>Sold</h3>
                                </div>
                                <h3>{event.ticketSold}</h3>
                              </div>

                              <div className="event-info-details">
                                <div className="event-info-details-title">
                                  <FontAwesomeIcon icon={faCoins} />
                                  <h3>Income</h3>
                                </div>
                                <h3>£ {event.income}</h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <h1 className="no-event">No Events</h1>
                    ) }
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}

      {createEvent && <CreateEvent />}
      {editEvent && <EditEvent />}
    </>
  );
};

export default Events;
